import React, { Component } from 'react'
import {Box,Typography,Grid,Divider} from '@mui/material'
import one from './background_img/bg10.jpg'
import {useNavigate, useParams,useLocation} from 'react-router-dom'
import ganpati from './img/ganpati.png'
import bg1 from '../src/background_img/bg1.jpg'
import bg2 from '../src/background_img/bg2.jpg'
import bg3 from '../src/background_img/bg3.jpg'
import bg4 from '../src/background_img/bg4.jpg'
import bg5 from '../src/background_img/bg5.jpg'
import bg6 from '../src/background_img/bg6.jpg'
import bg7 from '../src/background_img/bg7.jpg'
import bg8 from '../src/background_img/bg8.jpg'
import bg9 from '../src/background_img/bg9.jpg'
import bg10 from '../src/background_img/bg10.jpg'


export class Reports extends Component {
  constructor(props) {
    super(props)
  
    this.state = {
       data : ""
    }
  }


componentDidMount(){

  const searchParams = new URLSearchParams(this.props.location.search);
  const encodedData = searchParams.get('data');

 if (encodedData) {
    try {
      const jsonString = decodeURIComponent(encodedData);
      const receivedData = JSON.parse(jsonString);
          this.setState({
            data : receivedData
          })
   }catch (error) {
      console.error("Error parsing JSON:", error);
      
    }

}

}


  render() {
 
    return (
      <div>
        <Box sx={{height:'100vh',width:'100%',backgroundImage:`url(${this.state.data.bg_img})` , backgroundRepeat:'no-repeat', backgroundSize:'cover' }}>
         
         
         
                 <Box sx={{display:'flex',justifyContent:'center',alignItems:'center',pt:2}}>
                    <img src={ganpati} style={{height:100,width:100,objectFit:'contain'}}/>
                  </Box>
                   <Typography sx={{textAlign:'center',fontSize:30,fontWeight:'bold'}}> Bio Data </Typography>
            

             <br/>
             <br/>
          
             <Box sx={{pl:10,pr:10}}>
             <Typography sx={{textAlign:'left',fontSize:16,fontWeight:'bold',color:'#008ffb'}}>Personal Information</Typography>
           
             <Divider sx={{mt:2,mb:2}}/>

            <Grid container spacing={2}>
                 <Grid size={{xs:3}}>
                   
                     <Typography sx={{textAlign:'left',fontSize:11,fontWeight:'600',color:'#212121'}}>Name : </Typography>
                     <Typography sx={{textAlign:'left',fontSize:11,fontWeight:'600',color:'#212121',mt:0.5}}>Gender : </Typography>
                      <Typography sx={{textAlign:'left',fontSize:11,fontWeight:'600',color:'#212121',mt:0.5}}>Place of birth : </Typography>
                     <Typography sx={{textAlign:'left',fontSize:11,fontWeight:'600',color:'#212121',mt:0.5}}>Time of birth : </Typography>
                      <Typography sx={{textAlign:'left',fontSize:11,fontWeight:'600',color:'#212121',mt:0.5}}>Nakshatra : </Typography>
                      <Typography sx={{textAlign:'left',fontSize:11,fontWeight:'600',color:'#212121',mt:0.5}}>Height : </Typography>
                      <Typography sx={{textAlign:'left',fontSize:11,fontWeight:'600',color:'#212121',mt:0.5}}>Marrital status : </Typography>
                      <Typography sx={{textAlign:'left',fontSize:11,fontWeight:'600',color:'#212121',mt:0.5}}>Religion : </Typography>
                     <Typography sx={{textAlign:'left',fontSize:11,fontWeight:'600',color:'#212121',mt:0.5}}>Mother tongue : </Typography>
                      <Typography sx={{textAlign:'left',fontSize:11,fontWeight:'600',color:'#212121',mt:0.5}}>Cast : </Typography>

                 </Grid>
                 
                <Grid size={{xs:4}}>


                    <Typography sx={{textAlign:'left',fontSize:11,fontWeight:'600',color:'#201'}}>{this.state.data.name}</Typography>
                     <Typography sx={{textAlign:'left',fontSize:11,fontWeight:'600',color:'#212121',mt:0.5}}>{this.state.data.gender}</Typography>
                      <Typography sx={{textAlign:'left',fontSize:11,fontWeight:'600',color:'#212121',mt:0.5}}>{this.state.data.place_of_birth}</Typography>
                      <Typography sx={{textAlign:'left',fontSize:11,fontWeight:'600',color:'#212121',mt:0.5}}>{this.state.data.time_of_birth}</Typography>
                      <Typography sx={{textAlign:'left',fontSize:11,fontWeight:'600',color:'#212121',mt:0.5}}>{this.state.data.nakshtra}</Typography>
                      <Typography sx={{textAlign:'left',fontSize:11,fontWeight:'600',color:'#212121',mt:0.5}}>{this.state.data.height}</Typography>
                      <Typography sx={{textAlign:'left',fontSize:11,fontWeight:'600',color:'#212121',mt:0.5}}>{this.state.data.marrital_status}</Typography>
                      <Typography sx={{textAlign:'left',fontSize:11,fontWeight:'600',color:'#212121',mt:0.5}}>{this.state.data.religion}</Typography>
                      <Typography sx={{textAlign:'left',fontSize:11,fontWeight:'600',color:'#212121',mt:0.5}}>{this.state.data.mother_tongue}</Typography>
                      <Typography sx={{textAlign:'left',fontSize:11,fontWeight:'600',color:'#212121',mt:0.5}}>{this.state.data.cast}</Typography>


                 </Grid>

                   <Grid size={{xs:5}}>
                      
                      <Box sx={{width:'100%',display:'flex',justifyContent:'right',alignItems:'right'}}>
                       <img src={this.state.data.photo} style={{height:200,width:200,objectFit:'contain'}}/>
                      </Box>


                   </Grid>

            </Grid>


                  <Typography sx={{textAlign:'left',fontSize:16,fontWeight:'bold',color:'#008ffb',mt:3}}>Family Information</Typography>
           
             <Divider sx={{mt:2,mb:2}}/>

            <Grid container spacing={2}>
                 <Grid size={{xs:3}}>
                   
                     <Typography sx={{textAlign:'left',fontSize:11,fontWeight:'600',color:'#212121'}}>Father name : </Typography>
                     <Typography sx={{textAlign:'left',fontSize:11,fontWeight:'600',color:'#212121',mt:0.5}}>Father's Occupation : </Typography>
                      <Typography sx={{textAlign:'left',fontSize:11,fontWeight:'600',color:'#212121',mt:0.5}}>Mothers name : </Typography>
                     <Typography sx={{textAlign:'left',fontSize:11,fontWeight:'600',color:'#212121',mt:0.5}}>Mother occupation : </Typography>
                                          <Typography sx={{textAlign:'left',fontSize:11,fontWeight:'600',color:'#212121',mt:0.5}}>No of sister : </Typography>
                    <Typography sx={{textAlign:'left',fontSize:11,fontWeight:'600',color:'#212121',mt:0.5}}>No of brother : </Typography>
                 </Grid>
                 
                <Grid size={{xs:4}}>


                    <Typography sx={{textAlign:'left',fontSize:11,fontWeight:'600',color:'#201'}}>{this.state.data.father_name}</Typography>
                     <Typography sx={{textAlign:'left',fontSize:11,fontWeight:'600',color:'#212121',mt:0.5}}>{this.state.data.father_occupaion}</Typography>
                      <Typography sx={{textAlign:'left',fontSize:11,fontWeight:'600',color:'#212121',mt:0.5}}>{this.state.data.mother_name}</Typography>
                      <Typography sx={{textAlign:'left',fontSize:11,fontWeight:'600',color:'#212121',mt:0.5}}>{this.state.data.mother_occupation}</Typography>
                      <Typography sx={{textAlign:'left',fontSize:11,fontWeight:'600',color:'#212121',mt:0.5}}>{this.state.data.no_of_sistser}</Typography>
                                                                <Typography sx={{textAlign:'left',fontSize:11,fontWeight:'600',color:'#212121',mt:0.5}}>{this.state.data.no_of_brother}</Typography>  

                 </Grid>

            

            </Grid>

             <Typography sx={{textAlign:'left',fontSize:16,fontWeight:'bold',color:'#008ffb',mt:3}}>Contact Information</Typography>
           
             <Divider sx={{mt:2,mb:2}}/>

            <Grid container spacing={2}>
                 <Grid size={{xs:3}}>
                   
                     <Typography sx={{textAlign:'left',fontSize:11,fontWeight:'600',color:'#212121'}}>Phone no : </Typography>
                     <Typography sx={{textAlign:'left',fontSize:11,fontWeight:'600',color:'#212121',mt:0.5}}>Father's contact : </Typography>
                      <Typography sx={{textAlign:'left',fontSize:11,fontWeight:'600',color:'#212121',mt:0.5}}>Mothers contact : </Typography>
                     <Typography sx={{textAlign:'left',fontSize:11,fontWeight:'600',color:'#212121',mt:0.5}}>Address : </Typography>

                 </Grid>
                 
                <Grid size={{xs:4}}>


                    <Typography sx={{textAlign:'left',fontSize:11,fontWeight:'600',color:'#201'}}>{this.state.data.contact_no}</Typography>
                     <Typography sx={{textAlign:'left',fontSize:11,fontWeight:'600',color:'#212121',mt:0.5}}>{this.state.data.father_contact}</Typography>
                      <Typography sx={{textAlign:'left',fontSize:11,fontWeight:'600',color:'#212121',mt:0.5}}>{this.state.data.mother_contact_no}</Typography>
                      <Typography sx={{textAlign:'left',fontSize:11,fontWeight:'600',color:'#212121',mt:0.5}}>{this.state.data.address}</Typography>
                     

                 </Grid>

            

            </Grid>



           </Box>









        </Box>
      </div>
    )
  }
}

export default Reports


export function Reportsc(props){
  const navigate = useNavigate();
  const location = useLocation();
  const param = useParams()
  return (<Reports param={param} location={location} navigate={navigate}></Reports>)}